var exports = {
  "K": "IconButton__f9T_tY",
};

module.exports = exports;
